import React from 'react';
import { Link } from 'react-router-dom';
import './SimpleCard.css';

/**
 * SimpleCard Component
 * Display card for help center without icon
 * Same design as CategoryCard but without icon
 */
const SimpleCard = ({ title, description, route }) => {
  return (
    <Link to={route} className="simple-card">
      <h3 className="simple-card-title">{title}</h3>
      <p className="simple-card-description">{description}</p>
    </Link>
  );
};

export default SimpleCard;
